import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { VmeCommonModule } from '../../vme-common.module';
import { VMEComponentsModule } from '../../vme-components.module';
import { VmeDirectivesModule } from '../../vme-directives.module';
import { VmePipesModule } from '../../vme-pipes.module';
import { CustomerSitesComponent } from './customer-sites.component';
import { CustomerSitesOpeningTimesComponent } from './customer-sites-opening-times.component';
import { OverlayPanelInputComponent } from '../../user-controls/overlay-panel-input/overlay-panel-input.component';

const routes: Routes = [
  { path: '', component: CustomerSitesComponent, data: { title: 'Customer Sites' } },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class CustomerSitesRoutingModule {}

@NgModule({
  imports: [
    CustomerSitesRoutingModule,
    VmeCommonModule,
    VmeDirectivesModule,
    VmePipesModule,
    VMEComponentsModule,
    OverlayPanelInputComponent,
  ],
  declarations: [],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  exports: [CustomerSitesOpeningTimesComponent],
})
export class CustomerSitesModule {}
